import { checkingPreload, unCheckingPreload } from '../loading';
import { setAgentesListRedux, setAgenteRedux, setFormOptionsRedux } from './agentesSlice';
import {
  getAllAgentsService,
  getAgentByIdService,
  createAgentService,
  updateAgentService,
  deleteAgentService,
  restoreAgentService,
  getAgentsFormOptionsService,
} from '../../services/agents.service';
import { QueryPagination } from '../../commons/interfaces';

export const getDataFormDropDownStore = () => async (dispatch: any) => {
  dispatch(checkingPreload());
  try {
    const response = await getAgentsFormOptionsService();
    if (response?.ok) {
      dispatch(setFormOptionsRedux(response.data));
    }
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const getAllAgentsStore =
  (query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());
    try {
      const response = await getAllAgentsService(query);
      if (response.ok) {
        dispatch(setAgentesListRedux(response.data));
      }
      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const getAgentByIdStore = (id: string) => async (dispatch: any) => {
  dispatch(checkingPreload());
  try {
    const response = await getAgentByIdService(id);
    if (response?.ok) {
      dispatch(setAgenteRedux(response.data));
      if (response.data?.services) {
        dispatch(setFormOptionsRedux(response.data.services));
      }
    }
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const saveAgentStore = (data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());
  try {
    const response = await createAgentService(data);
    if (response.ok) {
      dispatch(setAgentesListRedux(response.data));
    }
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const editAgentStore = (id: string, data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());
  try {
    const response = await updateAgentService(id, data);
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const deleteAgentStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());
    try {
      const response = await deleteAgentService(id, query);
      if (response.ok) {
        dispatch(setAgentesListRedux(response.data));
      }
      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const restoreAgentStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());
    try {
      const response = await restoreAgentService(id, query);
      if (response.ok) {
        dispatch(setAgentesListRedux(response.data));
      }
      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };
